<template>
  <div style="flex-grow:1">
    <div class="radio-form-item__top-content">
      <div>
        <h4>Überführung per Spedition (Fremdachse)</h4>
        <p class="radio-form-item__price">ab € {{ price }} ,- <span class="mwst block">inkl. Mwst.</span></p>
      </div>
    </div>
    <p class="delivery-form__note">
      Keine Winterreifenpflicht beim Transport per Spedition.
    </p>
  </div>
</template>

<script>

export default {
  props: ['order'],
  computed: {
    privateBuyer() {
      return (this.order.private_buyer ? 'private' : 'comercial') || '';
    },
    commercialBuyer() {
      return this.privateBuyer == 'comercial';
    },
    price() {
      if (this.commercialBuyer) {
        return this.order.car_info.online_offer_services.all_services_b2b.delivery.transporter;
      }
      return this.order.car_info.online_offer_services.all_services.delivery.transporter;
    },
  },
};
</script>
